import { httpClient } from 'api/apiReqSagaCreator/httpRequest';
import { authCache } from 'api/cache';
import { AutomatedIndexingRepo } from 'container/services/automatedIndexing/AutomatedIndexingRepo';
import { IAutomatedIndexingRepo } from 'container/services/automatedIndexing/IAutomatedIndexingRepo';
import { RevenovaRepo } from 'container/services/revenova/RevenovaRepo';
import { AdjacentDocumentsRepo } from 'features/adjacentDocuments/services/AdjacentDocumentRepo';
import { IAdjacentDocumentsRepo } from 'features/adjacentDocuments/services/IAdjacentDocuments';
import { DriverSettlementsAsyncProcessInstanceRepo } from 'features/driver-settlements/services/asyncProcessInstances/DriverSettlementsAsyncProcessInstancesRepo';
import { IDriverSettlementsAsyncProcessInstanceRepo } from 'features/driver-settlements/services/asyncProcessInstances/IDriverSettlementsAsyncProcessInstancesRepo';
import { DriverSettlementsBatchRepo } from 'features/driver-settlements/services/batches/DriverSettlementsBatchRepo';
import { IDriverSettlementsBatchRepo } from 'features/driver-settlements/services/batches/IDriverSettlementsBatchRepo';
import { DriverSettlementsLogRepo } from 'features/driver-settlements/services/logs/DriverSettlementsLogRepo';
import { IDriverSettlementsLogRepo } from 'features/driver-settlements/services/logs/IDriverSettlementsLogRepo';
import { DriverSettlementsScenarioRepo } from 'features/driver-settlements/services/scenarios/DriverSettlementsScenarioRepo';
import { IDriverSettlementsScenariosRepo } from 'features/driver-settlements/services/scenarios/IDriverSettlementsScenarioRepo';
import { GeneralPayablesExtractionPlansRepo } from 'features/generalPayables/services/extractionPlans/GeneralPayablesExtractionPlansRepo';
import { IGeneralPayablesExtractionPlanRepo } from 'features/generalPayables/services/extractionPlans/IGeneralPayablesExtractionPlanRepo';
import { GeneralPayablesScenariosRepo } from 'features/generalPayables/services/scenarios/GeneralPayablesScenariosRepo';
import { IGeneralPayablesScenarioRepo } from 'features/generalPayables/services/scenarios/IGeneralPayablesScenarioRepo';
import { GeneralPayablesTaskRepo } from 'features/generalPayables/services/tasks/GeneralPayablesTaskRepo';
import { IGeneralPayablesTaskRepo } from 'features/generalPayables/services/tasks/IGeneralPayablesTaskRepo';
import { GeneralPayablesApprovalService } from 'features/generalPayablesApproval/services/GeneralPayablesApprovalService';
import { IGeneralPayablesApprovalService } from 'features/generalPayablesApproval/services/IGeneralPayablesApprovalService';
import { IMaintenancePayablesRepo } from 'features/maintenancePayables/services/IMaintenancePayablesRepo';
import { MaintenancePayablesRepo } from 'features/maintenancePayables/services/MaintenancePayablesRepo';
import { IOrderEntryRepo } from 'features/orderEntry/services/IOrderEntryRepo';
import { OrderEntryRepo } from 'features/orderEntry/services/OrderEntryRepo';
import { ISuspendedProcessInstanceService } from 'features/suspendedProcessInstances/services/ISuspendedProcessInstanceService';
import { SuspendedProcessInstanceService } from 'features/suspendedProcessInstances/services/SuspendedProcessInstanceService';

import { IServiceFactory } from './serviceFactoryInterface';
import { memoizeServiceFactory } from './serviceFactoryMemo';
import { ApplicationConfigurationRepo } from './services/applicationConfiguration/ApplicationConfigurationRepo';
import { IApplicationConfigurationRepo } from './services/applicationConfiguration/IApplicationConfiguraton';
import { BarcodeImporterProcessingRepo } from './services/barcodeImporter/processing/BarcodeImporterProcessingRepo';
import { IBarcodeImporterProcessingRepo } from './services/barcodeImporter/processing/IBarcodeImporterProcessingRepo';
import { BarcodeImporterScenarioRepo } from './services/barcodeImporter/scenarios/BarcodeImporterScenarioRepo';
import { IBarcodeImporterScenarioRepo } from './services/barcodeImporter/scenarios/IBarcodeImporterScenarioRepo';
import { BareClientRepo } from './services/bareClient/BareClientRepo';
import { IBareClientRepo } from './services/bareClient/IBareClientRepo';
import { E2OpenRepo } from './services/e2open/E2OpenRepo';
import { IE2OpenRepo } from './services/e2open/IE2Open';
import { EmailScenarioRepo } from './services/emailScenarios/EmailScenarioRepo';
import { IEmailScenarioRepo } from './services/emailScenarios/IEmailScenarioRepo';
import { EmailTemplateRepo } from './services/emailTemplates/EmailTemplateRepo';
import { IEmailTemplateRepo } from './services/emailTemplates/IEmailTemplateRepo';
import { ExternalFormsRepo } from './services/externalForms/ExternalFormsRepo';
import { IExternalFormsRepo } from './services/externalForms/IExternalForms';
import { ExternalSystemsRepo } from './services/externalSystemsRepo/ExternalSystemsRepo';
import { IExternalSystemsRepo } from './services/externalSystemsRepo/IExternalSystemsRepo';
import { FieldAliasesRepo } from './services/fieldAliases/FieldAliasesRepo';
import { IFieldAliasesRepo } from './services/fieldAliases/IFieldAliases';
import { FormRepo } from './services/form/FormRepo';
import { IFormRepo } from './services/form/IFormRepo';
import { FreshdeskTokenRepo } from './services/freshdeskToken/freshdeskTokenRepo';
import { IFreshdeskTokenRepo } from './services/freshdeskToken/IFreshdeskTokenRepo';
import { FtpRepo } from './services/ftp/FtpRepo';
import { IFtpRepo } from './services/ftp/IFtp';
import { GridRepo } from './services/grid/GridRepo';
import { IGridRepo } from './services/grid/IGridRepo';
import { IIndexingDocumentsRepo } from './services/indexingDocuments/IIndexingDocumentsRepo';
import { IndexingDocumentRepo } from './services/indexingDocuments/IndexingDocumentRepo';
import { IIndexingSourcesRepo } from './services/indexingSources/IIndexingSourcesRepo';
import { IndexingSourcesRepo } from './services/indexingSources/IndexingSourcesRepo';
import { IInvitationsRepo } from './services/invitations/IInvitations';
import { InvitationsRepo } from './services/invitations/InvitationsRepo';
import { ILicenseRepo } from './services/licenses/ILicenses';
import { LicenseRepo } from './services/licenses/LicenseRepo';
import { IManagementEmailRepo } from './services/managementEmail/IManagementEmailRepo';
import { ManagementEmailRepo } from './services/managementEmail/ManagementEmailRepo';
import { IManagementFTPRepo } from './services/managementFTP/IManagementFTPRepo';
import { ManagementFTPRepo } from './services/managementFTP/ManagementFTPRepo';
import { IManagementLogsRepo } from './services/managementLogs/IManagementLogsRepo';
import { ManagementLogsRepo } from './services/managementLogs/ManagementLogsRepo';
import { IManagementOIDCRepo } from './services/managementOIDC/IManagementOIDC';
import { ManagementOIDCRepo } from './services/managementOIDC/ManagementOIDCRepo';
import { IManagementUsersRepo } from './services/managementUsers/IManagementUsers';
import { ManagementUsersRepo } from './services/managementUsers/ManagementUsersRepo';
import { IPrintRenderLogRepo } from './services/printRenderLogs/IPrintRenderRepo';
import { PrintRenderLogsRepo } from './services/printRenderLogs/printRenderLogsRepo';
import { IPrintRenderOverridesRepo } from './services/printRenderOverrides/IPrintRenderOverrides';
import { PrintRenderOverridesRepo } from './services/printRenderOverrides/PrintRenderOverridesRepo';
import { IProcessRepo } from './services/process/IProcessRepo';
import { ProcessRepo } from './services/process/ProcessRepo';
import { IProcessInstanceRepo } from './services/ProcessInstance/IProcessInstanceRepo';
import { ProcessInstanceRepo } from './services/ProcessInstance/ProcessInstanceRepo';
import { IProcessInstanceRelatedDocumentRepo } from './services/processInstanceRelatedDocuments/IProcessInstanceRelatedDocumentRepo';
import { ProcessInstanceRelatedDocumentRepo } from './services/processInstanceRelatedDocuments/ProcessInstanceRelatedDocumentRepo';
import { IProcessInstanceRepoV2 } from './services/ProcessInstanceV2/IProcessInstanceRepo';
import { ProcessInstanceRepoV2 } from './services/ProcessInstanceV2/ProcessInstanceRepo';
import { IRevenovaRepo } from './services/revenova/IRevenova';
import { IScanRepo } from './services/Scan/IScanRepo';
import { ScanRepo } from './services/Scan/scanRepo';
import { IScanScenarioRepo } from './services/ScanScenario/IScanScenarioRepo';
import { ScanScenarioRepo } from './services/ScanScenario/ScanScenarioRepo';
import { ISearchTemplateRepo } from './services/searchTemplates/ISearchTemplateRepo';
import { SearchTemplateRepo } from './services/searchTemplates/SearchTemplateRepo';
import { ISecurityRepo } from './services/security/ISecurityRepo';
import { SecurityRepo } from './services/security/SecurityRepo';
import { ISystemLogsRepo } from './services/systemLogs/ISystemLogsRepo';
import { SystemLogsRepo } from './services/systemLogs/systemLogsRepo';
import { ITenantsRepo } from './services/tenants/ITenants';
import { TenantsRepo } from './services/tenants/TenantsRepo';
import { ITmsRepo } from './services/tms/ITmsRepo';
import { TmsRepo } from './services/tms/TmsRepo';
import { ITmsConnectionRepo } from './services/tmsConnections/ITmsConnection';
import { TmsConnectionRepo } from './services/tmsConnections/TmsConnectionRepo';
import { IUserRepo } from './services/users/IUserRepo';
import { UserRepo } from './services/users/UserRepo';

export interface ServiceContext {
  tokenStateAccessor: () => Tokens;
}

export class ServiceFactory implements IServiceFactory {
  private static tokenStateAccessor(): Tokens {
    return {
      accessToken: authCache.authToken,
      refreshToken: authCache.exchangeToken,
    };
  }

  private static serviceContext: ServiceContext = {
    tokenStateAccessor: ServiceFactory.tokenStateAccessor,
  };

  public getScanRepo(): IScanRepo {
    return new ScanRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getPrintRenderRepo(): IPrintRenderLogRepo {
    return new PrintRenderLogsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getIndexingSourceRepo(): IIndexingSourcesRepo {
    return new IndexingSourcesRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getIndexingDocumentsRepo(): IIndexingDocumentsRepo {
    return new IndexingDocumentRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getProcessInstanceRepo(): IProcessInstanceRepo {
    return new ProcessInstanceRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getProcessInstanceRepoV2(): IProcessInstanceRepoV2 {
    return new ProcessInstanceRepoV2(httpClient, ServiceFactory.serviceContext);
  }

  public getScanScenarioRepo(): IScanScenarioRepo {
    return new ScanScenarioRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getFreshdeskTokenRepo(): IFreshdeskTokenRepo {
    return new FreshdeskTokenRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getSystemLogsRepo(): ISystemLogsRepo {
    return new SystemLogsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getManagementLogsRepo(): IManagementLogsRepo {
    return new ManagementLogsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getUserRepo(): IUserRepo {
    return new UserRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getManagementEmailRepo(): IManagementEmailRepo {
    return new ManagementEmailRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getProcessRepo(): IProcessRepo {
    return new ProcessRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getBareClientRepo(): IBareClientRepo {
    return new BareClientRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getFieldAliasRepo(): IFieldAliasesRepo {
    return new FieldAliasesRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getGridRepo(): IGridRepo {
    return new GridRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getExternalFormsRepo(): IExternalFormsRepo {
    return new ExternalFormsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getSecurityRepo(): ISecurityRepo {
    return new SecurityRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getFormRepo(): IFormRepo {
    return new FormRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getApplicationConfigurationRepo(): IApplicationConfigurationRepo {
    return new ApplicationConfigurationRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getManagementOIDCRepo(): IManagementOIDCRepo {
    return new ManagementOIDCRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getTenantsRepo(): ITenantsRepo {
    return new TenantsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getOrderEntryRepo(): IOrderEntryRepo {
    return new OrderEntryRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getE2OpenRepo(): IE2OpenRepo {
    return new E2OpenRepo(httpClient, ServiceFactory.serviceContext);
  }

  getRevenovaRepo(): IRevenovaRepo {
    return new RevenovaRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getBarcodeImporterProcessingRepo(): IBarcodeImporterProcessingRepo {
    return new BarcodeImporterProcessingRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getBarcodeImporterScenarioRepo(): IBarcodeImporterScenarioRepo {
    return new BarcodeImporterScenarioRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getEmailScenarioRepo(): IEmailScenarioRepo {
    return new EmailScenarioRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getManagementFTPRepo(): IManagementFTPRepo {
    return new ManagementFTPRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getInvitationsRepo(): IInvitationsRepo {
    return new InvitationsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getLicenseRepo(): ILicenseRepo {
    return new LicenseRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getManagementUsersRepo(): IManagementUsersRepo {
    return new ManagementUsersRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getTmsConnectionRepo(): ITmsConnectionRepo {
    return new TmsConnectionRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getMaintenancePayablesRepo(): IMaintenancePayablesRepo {
    return new MaintenancePayablesRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getTmsRepo(): ITmsRepo {
    return new TmsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getEmailTemplatesRepo(): IEmailTemplateRepo {
    return new EmailTemplateRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getFtpRepo(): IFtpRepo {
    return new FtpRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getPrintRenderOverridesRepo(): IPrintRenderOverridesRepo {
    return new PrintRenderOverridesRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getExternalSystemsRepo(): IExternalSystemsRepo {
    return new ExternalSystemsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getAutomatedIndexingRepo(): IAutomatedIndexingRepo {
    return new AutomatedIndexingRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getGeneralPayablesScenarioRepo(): IGeneralPayablesScenarioRepo {
    return new GeneralPayablesScenariosRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }
  public getGeneralPayablesExtractionPlanRepo(): IGeneralPayablesExtractionPlanRepo {
    return new GeneralPayablesExtractionPlansRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getGeneralPayablesTaskRepo(): IGeneralPayablesTaskRepo {
    return new GeneralPayablesTaskRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getGeneralPayablesApprovalService(): IGeneralPayablesApprovalService {
    return new GeneralPayablesApprovalService(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getSearchTemplateRepo(): ISearchTemplateRepo {
    return new SearchTemplateRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getAdjacentDocumentsRepo(): IAdjacentDocumentsRepo {
    return new AdjacentDocumentsRepo(httpClient, ServiceFactory.serviceContext);
  }

  public getDriverSettlementsScenarioRepo(): IDriverSettlementsScenariosRepo {
    return new DriverSettlementsScenarioRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getDriverSettlementsLogRepo(): IDriverSettlementsLogRepo {
    return new DriverSettlementsLogRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getDriverSettlementsBatchRepo(): IDriverSettlementsBatchRepo {
    return new DriverSettlementsBatchRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getProcessInstanceRelatedDocumentRepo(): IProcessInstanceRelatedDocumentRepo {
    return new ProcessInstanceRelatedDocumentRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getDriverSettlementsAsyncProcessInstanceRepo(): IDriverSettlementsAsyncProcessInstanceRepo {
    return new DriverSettlementsAsyncProcessInstanceRepo(
      httpClient,
      ServiceFactory.serviceContext
    );
  }

  public getSuspendedProcessInstanceService(): ISuspendedProcessInstanceService {
    return new SuspendedProcessInstanceService(
      httpClient,
      ServiceFactory.serviceContext
    );
  }
}

export const serviceFactory: IServiceFactory = memoizeServiceFactory(
  new ServiceFactory()
);
